import httpClient from './httpClient';

export const ABANDONED_CART_ENDPOINT = '/backoffice/abandoned-carts';

export const getAbandonedCartsAPI = (params = {}) => httpClient.get(ABANDONED_CART_ENDPOINT, { params });
export const postExportAbandonedCartReport = (params = {}) => httpClient.post(`${ABANDONED_CART_ENDPOINT}/reports/export`, params);